import React from 'react';
import { AlertsPanel } from '../components/organisms/AlertsPanel';

export const AlertsPage: React.FC = () => (
  <div data-testid="alerts-page">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Price Alerts</h1>
    <AlertsPanel />
  </div>
);